import { render, staticRenderFns } from "./Foster.vue?vue&type=template&id=17c81dd7&scoped=true&lang=html&"
import script from "./Foster.vue?vue&type=script&lang=js&"
export * from "./Foster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c81dd7",
  null
  
)

export default component.exports